import { DateTime } from "luxon";
import { Timeframe } from "src/app/shared/types/hydrao-types";
import { Model } from "./model";

export class Filters implements Model {
  constructor(
    public date: DateTime,
    public timeframe: Timeframe,
    public placeId: number
  ) {}

  public hasChanges(newFilters: Filters) {
    return (
      !newFilters.date.equals(this.date) ||
      newFilters.placeId !== this.placeId ||
      newFilters.timeframe + "" !== this.timeframe + ""
    );
  }

  public clone(): Filters {
    return new Filters(this.date, this.timeframe, this.placeId);
  }
}
